import './App.css';
import { Pages } from './pages/pages';

function App() {
  return (
    <div className='font-montSerrat pt-6 pb-48 relative min-h-[100vh]'>
      <Pages />
    </div>
  );
}

export default App;
